import { render, staticRenderFns } from "./FacilityRecordDialog.vue?vue&type=template&id=ddb02d4c&scoped=true&"
import script from "./FacilityRecordDialog.vue?vue&type=script&lang=js&"
export * from "./FacilityRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb02d4c",
  null
  
)

export default component.exports